import tools from '../../utiltools/tools'
import ajax from '../../utiltools/ajax'
import Axios from '../../plugins/AxiosPlugin'
import swal from 'sweetalert'
import appconst from '../../utiltools/appconst'
import {
  requestPasswordToken,
  requestCaptcha,
  requestRefreshToken,
  revokeRefreshToken
} from '../../auth/openIddictClient'
import {
  activateAuthSession,
  runSingleFlightRefresh
} from '../../auth/authSession'
import {
  handleAuthenticationFailure,
  resetAuthenticationFailure
} from '../../auth/authenticationFailure'
import { performLogout } from '../../auth/logout'
import {
  clearTokenMetadata,
  createTokenState,
  persistTokenMetadata,
  readPersistedTokenState
} from '../../auth/tokenState'
import { restoreCurrentSession } from '../../auth/currentSession'

export default {
  state: {
    token: null,
    refreshToken: null,
    tokenType: null,
    tokenExpiresAt: null,
    currentUser: null,
    currentTenant: null
  },
  mutations: {
    setToken(state, val) {
      const next = createTokenState(val, state)
      const tokenExpireDate = new Date(next.tokenExpiresAt)

      state.token = next.accessToken
      state.refreshToken = next.refreshToken
      state.tokenType = next.tokenType
      state.tokenExpiresAt = next.tokenExpiresAt
      window.abp.auth.setToken(
        next.accessToken,
        tokenExpireDate
      )
      window.abp.auth.setRefreshToken(
        next.refreshToken,
        new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 14)
      )
      persistTokenMetadata(window.localStorage, next)
    },

    readToken(state) {
      const persisted = readPersistedTokenState(window.abp.auth, window.localStorage)
      state.token = persisted.accessToken
      state.refreshToken = persisted.refreshToken
      state.tokenType = persisted.tokenType
      state.tokenExpiresAt = persisted.tokenExpiresAt
      if (!state.token) {
        state.currentUser = null
        state.currentTenant = null
      }
    },

    setCurrentSession(state, session) {
      state.currentUser = session.user
      state.currentTenant = session.tenant
      window.abp.session.user = session.user
      window.abp.session.tenant = session.tenant
    },

    unsetToken(state) {
      state.token = null
      state.refreshToken = null
      state.tokenType = null
      state.tokenExpiresAt = null
      state.currentUser = null
      state.currentTenant = null

      window.abp.auth.clearToken()
      window.abp.auth.clearRefreshToken()
      clearTokenMetadata(window.localStorage)
      window.localStorage.removeItem('currentUser')
      window.abp.session.user = null
      window.abp.session.tenant = null
    }
  },
  getters: {
    isAuthenticated(state) {
      //用两个!!就可以将变量转化为对应布尔值
      //，如果明确设置了o中flag的值（非 null/undefined/0""/等值），自然test就会取跟o.flag一样的值；如果没有设置，test就会默认为false，而不是 null或undefined。
      return !!state.currentUser
    },
    currentUser(state) {
      return state.currentUser
    },
    currentTenant(state) {
      return state.currentTenant
    },
    token(state) {
      return state.token
    },
    refreshToken(state) {
      return state.refreshToken
    },
    isTokenExpired(state) {
      return !state.tokenExpiresAt || state.tokenExpiresAt - Date.now() < 60000
    }
  },
  actions: {
    async isTenantAvailable(context, payload) {
      let res = await ajax.post(
        '/api/services/app/Account/IsTenantAvailable',
        payload.data
      )
      return res.data.result
    },
    async changePassword(context, payload) {
      let res = await Axios.post(
        '/api/services/app/User/ChangePassword',
        payload.data
      )
      return res.data.result
    },
    async changeLanguage(context, payload) {
      let res = await Axios.post(
        '/api/services/app/User/ChangeLanguage',
        payload.data
      )
      return res.data.result
    },
    async userLogin(
      context,
      { userNameOrEmailAddress, password, captchaId, captchaCode, Rurl = '/home' }
    ) {
      const tenantId = window.abp.multiTenancy.getTenantIdCookie()
      let response
      try {
        response = await requestPasswordToken(
          userNameOrEmailAddress,
          password,
          tenantId,
          captchaId,
          captchaCode
        )
      } catch (error) {
        const response = error.response
        const description = response && response.data && response.data.error_description
        await swal({
          title: window.abp.localization.localize('LoginFailed'),
          text: description || 'Unable to sign in.',
          icon: 'error'
        })
        throw error
      }

      activateAuthSession()
      resetAuthenticationFailure()
      context.commit('setToken', response.data)
      await context.dispatch('restoreCurrentSession')
      await context.dispatch('loadAbpConfiguration')
      location.replace(Rurl)
    },
    async loadCaptcha() {
      const tenantId = window.abp.multiTenancy.getTenantIdCookie()
      const response = await requestCaptcha(tenantId)
      return response.data.result || response.data
    },
    async restoreCurrentSession(context) {
      return restoreCurrentSession({
        fetchSession: () => Axios.get(
          '/api/services/app/Session/GetCurrentLoginInformations'
        ),
        applySession: session => context.commit('setCurrentSession', session),
        failAuthentication: () => handleAuthenticationFailure({
          clear: () => context.commit('unsetToken'),
          navigate: () => {
            if (window.location.pathname !== '/login') window.location.replace('/login')
          }
        })
      })
    },
    async loadAbpConfiguration() {
      const response = await ajax.get('/AbpUserConfiguration/GetAll')
      window.abp = tools.extend(true, window.abp, response.data.result)
      window.abp.localization.defaultSourceName =
        appconst.localization.defaultLocalizationSourceName
      return response.data.result
    },
    async refreshToken(context) {
      return runSingleFlightRefresh(async () => {
        const refreshToken = context.state.refreshToken || window.abp.auth.getRefreshToken()
        if (!refreshToken) throw new Error('No refresh token is available.')

        const response = await requestRefreshToken(refreshToken)
        return response.data
      }, tokenResponse => context.commit('setToken', tokenResponse))
    },
    async logout(context) {
      const refreshToken = context.state.refreshToken || window.abp.auth.getRefreshToken()
      return performLogout({
        refreshToken,
        terminate: () => handleAuthenticationFailure({
          clear: () => context.commit('unsetToken'),
          navigate: () => undefined
        }),
        revoke: revokeRefreshToken,
        warn: () => console.warn('Refresh token revocation failed during logout.')
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/Users.js